export default __webpack_public_path__ + "images/771fdb3aefc422f77795bd60f8e6884c.jpg";